import { NotificationType } from '../models/notification.interfaces';

export const startDismissTimer = (
  type: NotificationType,
  dismissAfter: number,
  hideTimeout: ReturnType<typeof setTimeout> | null,
  setHideTimeout: (timeout: ReturnType<typeof setTimeout> | null) => void,
  onDismiss: () => void
) => {
  if (type === 'success') {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
    }

    const timeout = setTimeout(() => {
      onDismiss();
    }, dismissAfter);

    setHideTimeout(timeout);
  }
};
